<div
  class="dashboard-location-preferences"
  data-cy="dashboard-location-preferences">

  <coa-dashboard-location-preferences-header
    [location]="location$ | async"
    [locations]="locations$ | async"
    class="dashboard-location-preferences-header">
  </coa-dashboard-location-preferences-header>

  <coa-dashboard-location-preferences-body
    [clientLocationPreferences]="clientLocationPreferences$ | async"
    class="dashboard-location-preferences-body">
  </coa-dashboard-location-preferences-body>
</div>
